import '../../assets/beautrium-css/coupon-line.scss'

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { moneyFormat } from '../../assets/util';
import moment from 'moment'
import { withRouter } from 'react-router-dom'
import { swal, close } from 'react-redux-sweetalert'
import { collectCoupon, storeCouponAuth, setCouponListDisplay } from '../../actions/coupon';
import { DELIVERY_COST } from '../../config';

class CouponLine extends Component {
    constructor(props) {
        super(props)

        this.handleCollectCoupon = this.handleCollectCoupon.bind(this)
        this.onClickOption = this.onClickOption.bind(this)
        this.renderButtonText = this.renderButtonText.bind(this)
    }

    componentDidUpdate(prevProps) {
        const listener = typeof this.props.listener !== "undefined" ? this.props.listener : true;
        if (listener) {
            if (prevProps.collect_coupon === false && this.props.collect_coupon) {
                const { collect_coupon } = this.props
                this.props.swal({
                    type: collect_coupon.type,
                    title: collect_coupon.title,
                    text: collect_coupon.text,
                    onConfirm: () => {
                        this.props.close();
                        if (typeof this.props.onSuccessCollected === "function") {
                            this.props.onSuccessCollected();
                        }
                    },
                    customClass: 'bt-dialog-box',
                });
            }
        }
    }

    handleCollectCoupon(coupon) {
        if (this.props.authenticated) {
            this.props.collectCoupon(this.props.profile.user_id, coupon.id)
        } else {
            const { onFailedCollected } = this.props
            this.props.storeCouponAuth(coupon)
            if (typeof onFailedCollected === "function") {
                onFailedCollected()
            } else {
                this.props.history.push('/login')
            }
        }
    }

    getCollectedStatus(coupon) {
        return coupon ? coupon.collected_status : null
    }

    onClickOption(coupon) {
        const { needAuth, useCoupon } = this.props
        const collected = this.getCollectedStatus(coupon) || !this.isCouponStarted(coupon) || this.isCouponExpired(coupon) || coupon.collectable === false || (coupon.pickup_quantity && coupon.picked_quantity >= coupon.pickup_quantity) || coupon.remain === 0 || needAuth
        if ((this.props.selectCoupon && typeof this.props.selectCoupon === "function") && useCoupon) {
            this.props.selectCoupon(coupon.promo_code)
            this.props.setCouponListDisplay(false)
        } else if (!collected && !needAuth) {
            this.handleCollectCoupon(coupon)
        }
    }

    isCouponStarted(coupon) {
        const now = moment();
        return moment(coupon.start_date).isSameOrBefore(now, 's') || (moment(coupon.pickup_start_date).isValid() && moment(coupon.pickup_start_date).isSameOrBefore(now, 's'));
    }

    isCouponExpired(coupon) {
        return moment(coupon.end_date).isBefore(moment(), 's')
    }

    renderButtonText(coupon) {
        const { needAuth, useCoupon, authenticated } = this.props
        const isCouponStarted = this.isCouponStarted(coupon)
        const isCouponExpired = this.isCouponExpired(coupon)
        const collected = this.getCollectedStatus(coupon)

        let text = ''
        if (coupon.remain === 0) {
            text = 'สิทธิครบแล้ว'
        } else if (useCoupon) {
            text = 'ใช้คูปอง'
        } else if (coupon.pickup_quantity && coupon.pickup_quantity <= coupon.picked_quantity) {
            text = 'คูปองหมดแล้ว'
        } else if (coupon.pickup_start_date && moment(coupon.pickup_start_date).isAfter(moment(), 's')) {
            text = `เริ่ม ${moment(coupon.pickup_start_date).format("DD/MM/YYYY")}`
        } else if (!coupon.pickup_start_date && !isCouponStarted) {
            text = `เริ่ม ${moment(coupon.start_date).format("DD/MM/YYYY")}`
        } else if (isCouponExpired) {
            text = 'หมดอายุ'
        } else if (needAuth) {
            text = 'เข้าสู่ระบบเพื่อรับ'
        } else if (authenticated) {
            if (collected) {
                text = 'เก็บคูปองแล้ว'
            } else if (coupon.collectable === false) {
                if (coupon.new_user === 1) {
                    text = 'เฉพาะลูกค้าใหม่'
                } else {
                    text = 'ไม่สามารถเก็บได้'
                }
            } else {
                text = 'รับคูปอง'
            }
        } else {
            text = 'รับคูปอง'
        }
        return text
    }

    render() {
        const { coupon, useCoupon, needAuth } = this.props;
        if (!coupon) return null

        const collected = this.getCollectedStatus(coupon) || !this.isCouponStarted(coupon) || this.isCouponExpired(coupon) || coupon.collectable === false || coupon.remain === 0 || needAuth
        return (
            <div className="coupon-line">
                <div className="coupon-detail">
                    <div className="coupon-discount-detail">
                        <div className="coupon-type">{coupon.type === "transport" ? (coupon.discount_amt >= DELIVERY_COST ? 'ฟรีค่าส่ง' : ('ลดค่าส่ง ' + (coupon.discount_percent ? coupon.discount_percent + "%" : coupon.discount_amt + '.-'))) : "ส่วนลด " + (coupon.discount_amt ? moneyFormat(coupon.discount_amt, '฿', 0) : coupon.discount_percent + "%")}</div>
                        <div className="coupon-code">{coupon.promo_code}</div>
                        <div className="coupon-condition">
                            {coupon.new_user ? <span className="mr-2">สำหรับลูกค้าใหม่</span> : null}
                            {coupon.min_spend ? <span className="mr-2">ยอดขั้นต่ำ {moneyFormat(coupon.min_spend, '฿', 0)}</span> : null}
                            {coupon.max_cap ? <span className="mr-2">ลดสูงสุด {moneyFormat(coupon.max_cap, '฿', 0)}</span> : null}
                        </div>
                        <div className="coupon-expire">
                            ใช้ได้ถึงวันที่ {moment(coupon.end_date).format("DD MMM YYYY HH:mm:ss")}
                        </div>
                    </div>
                </div>
                <div>
                    <button type="button" className="btn btn-primary" disabled={!useCoupon ? collected : false} onClick={(e) => { this.onClickOption(coupon) }}>{this.renderButtonText(coupon)}</button>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        authenticated: state.auth.authenticated,
        profile: state.prof.profile,
        collect_coupon: state.coupon.collect_coupon,
    }
}
export default withRouter(connect(mapStateToProps, { collectCoupon, storeCouponAuth, setCouponListDisplay, swal, close })(CouponLine))